module.exports = __webpack_public_path__ + "img/activeicon-kvdr.d30afbf3.svg";